module.exports = __webpack_public_path__ + "img/button_suffix_on.55faf257.svg";